(function () {
  "use strict";

  window.BURR_PAW = window.BURR_PAW || {};

  function showToast(message) {
    var toast = document.getElementById("site-toast");
    if (!toast) {
      toast = document.createElement("div");
      toast.id = "site-toast";
      toast.className = "toast";
      toast.setAttribute("role", "status");
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add("is-visible");
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () {
      toast.classList.remove("is-visible");
    }, 2400);
  }

  window.BURR_PAW.showToast = showToast;

  function initHeader() {
    var header = document.querySelector(".site-header");
    var toggle = document.querySelector(".menu-toggle");
    var nav = document.querySelector(".primary-nav");
    var searchToggle = document.querySelector("[data-search-toggle]");
    var searchDrawer = document.getElementById("search-drawer");
    if (!header) return;

    var backdrop = document.querySelector(".nav-backdrop");
    if (!backdrop) {
      backdrop = document.createElement("div");
      backdrop.className = "nav-backdrop";
      backdrop.setAttribute("aria-hidden", "true");
      document.body.appendChild(backdrop);
    }

    if (nav && !nav.querySelector(".nav-drawer-foot")) {
      var foot = document.createElement("div");
      foot.className = "nav-drawer-foot";
      var phone = document.body.getAttribute("data-store-phone-tel") || "+14023708050";
      var phoneLabel = document.body.getAttribute("data-store-phone") || "1 (402) 370-8050";
      foot.innerHTML = '<a href="tel:' + phone + '">' + phoneLabel + "</a>";
      nav.appendChild(foot);
    }

    function setNavOpen(open) {
      if (!toggle || !nav) return;
      toggle.setAttribute("aria-expanded", String(open));
      toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
      nav.classList.toggle("is-open", open);
      header.classList.toggle("is-nav-open", open);
      document.body.classList.toggle("is-nav-open", open);
      backdrop.classList.toggle("is-visible", open);
      backdrop.setAttribute("aria-hidden", open ? "false" : "true");
    }

    function onScroll() {
      header.classList.toggle("is-scrolled", window.scrollY > 12);
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    if (toggle && nav) {
      toggle.addEventListener("click", function () {
        setNavOpen(toggle.getAttribute("aria-expanded") !== "true");
      });
      backdrop.addEventListener("click", function () {
        setNavOpen(false);
      });
      nav.querySelectorAll("a").forEach(function (link) {
        link.addEventListener("click", function () {
          setNavOpen(false);
        });
      });
      window.addEventListener("keydown", function (event) {
        if (event.key === "Escape") setNavOpen(false);
      });
      window.addEventListener("resize", function () {
        var isTouchTablet =
          window.matchMedia("(hover: none) and (pointer: coarse)").matches &&
          window.innerWidth <= 1400;
        if (window.innerWidth > 1100 && !isTouchTablet) setNavOpen(false);
      });
    }

    if (searchToggle && searchDrawer) {
      searchToggle.addEventListener("click", function () {
        setNavOpen(false);
        var isHidden = searchDrawer.hasAttribute("hidden");
        if (isHidden) {
          searchDrawer.removeAttribute("hidden");
          var input = searchDrawer.querySelector("input");
          if (input) input.focus();
        } else {
          searchDrawer.setAttribute("hidden", "");
        }
      });
    }
  }

  function initHeroVideo() {
    var hero = document.querySelector(".hero-video");
    var video = document.querySelector(".hero-video video");
    var restoreBtn = document.querySelector("[data-hero-restore]");
    if (!hero) return;

    function markReady() {
      if (video) video.classList.add("is-ready");
    }

    function setWatching(on) {
      hero.classList.toggle("is-watching", on);
      var copy = hero.querySelector(".hero-video__copy");
      if (copy) {
        if (on) copy.setAttribute("aria-hidden", "true");
        else copy.removeAttribute("aria-hidden");
      }
      if (restoreBtn) {
        if (on) restoreBtn.removeAttribute("hidden");
        else restoreBtn.setAttribute("hidden", "");
      }
    }

    function tryPlay(unmuted) {
      if (!video) return Promise.resolve();
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "");
      video.setAttribute("muted", "");
      video.playsInline = true;
      video.loop = true;
      video.muted = !unmuted;
      if (!unmuted) {
        // Some browsers only allow autoplay when the muted property is set before play().
        try {
          video.defaultMuted = true;
        } catch (e) {}
      }
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === "function") {
        return playPromise.catch(function () {
          if (unmuted) {
            video.muted = true;
            return video.play().catch(function () {
              markReady();
            });
          }
          markReady();
        });
      }
      return Promise.resolve();
    }

    function enterWatching(event) {
      if (event && event.target.closest("a, button, input, label, [data-hero-restore]")) return;
      if (hero.classList.contains("is-watching")) return;
      setWatching(true);
      tryPlay(true);
    }

    if (video) {
      markReady();
      ["loadeddata", "loadedmetadata", "canplay", "playing", "error"].forEach(function (evt) {
        video.addEventListener(evt, markReady);
      });

      // Kick loading, then muted autoplay.
      try {
        video.load();
      } catch (e) {}
      tryPlay(false);

      // Retry once media is actually ready (first play() can race an empty buffer).
      video.addEventListener(
        "canplay",
        function () {
          if (video.paused) tryPlay(false);
        },
        { once: true }
      );

      window.setTimeout(function () {
        if (video.paused) tryPlay(false);
        markReady();
      }, 800);
    }

    if (restoreBtn) {
      restoreBtn.addEventListener("click", function (event) {
        event.stopPropagation();
        setWatching(false);
        if (video) {
          video.muted = true;
          tryPlay(false);
        }
      });
    }

    var watchLock = false;
    hero.addEventListener("pointerup", function (event) {
      if (event.pointerType === "mouse" && event.button !== 0) return;
      if (watchLock) return;
      watchLock = true;
      window.setTimeout(function () {
        watchLock = false;
      }, 400);
      enterWatching(event);
    });
  }

  function initReveals() {
    var nodes = document.querySelectorAll("[data-reveal]");
    if (!nodes.length) return;

    function reveal(n) {
      n.classList.add("is-in");
    }

    if (!("IntersectionObserver" in window)) {
      nodes.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -4% 0px" }
    );

    nodes.forEach(function (n) {
      var rect = n.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.95 && rect.bottom > 0) {
        reveal(n);
      } else {
        io.observe(n);
      }
    });

    // Safety: never leave homepage sections stuck invisible
    window.setTimeout(function () {
      nodes.forEach(reveal);
    }, 1500);
  }

  function initAddButtons() {
    function resolveVariantId(btn) {
      var variantId = btn.getAttribute("data-variant-id");
      if (variantId) return Promise.resolve(variantId);
      var handle = btn.getAttribute("data-product-handle");
      if (!handle) return Promise.resolve("");
      return fetch("/products/" + encodeURIComponent(handle) + ".js", {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      })
        .then(function (res) {
          if (!res.ok) throw new Error("product");
          return res.json();
        })
        .then(function (product) {
          var variants = (product && product.variants) || [];
          var available = null;
          for (var i = 0; i < variants.length; i++) {
            if (variants[i] && variants[i].available) {
              available = variants[i];
              break;
            }
          }
          var chosen = available || variants[0];
          var id = chosen && chosen.id ? String(chosen.id) : "";
          if (id) btn.setAttribute("data-variant-id", id);
          return id;
        })
        .catch(function () {
          return "";
        });
    }

    document.addEventListener("click", function (event) {
      var btn = event.target.closest("[data-add-to-cart]");
      if (!btn || btn.disabled) return;
      event.preventDefault();
      event.stopPropagation();

      if (!window.BURR_PAW_CART) {
        showToast("Cart is still loading — try again");
        return;
      }

      var qtyAttr = btn.getAttribute("data-qty");
      var qty;
      if (qtyAttr != null && qtyAttr !== "") {
        qty = Number(qtyAttr) || 1;
      } else {
        var qtyEl = document.querySelector("[data-qty] input");
        qty = qtyEl ? Number(qtyEl.value || 1) : 1;
      }

      btn.disabled = true;
      resolveVariantId(btn).then(function (variantId) {
        if (!variantId) {
          btn.disabled = false;
          showToast("Could not add to cart");
          return;
        }
        window.BURR_PAW_CART
          .addVariant(variantId, qty)
          .then(function () {
            showToast("Added to cart");
          })
          .catch(function () {
            showToast("Could not add to cart");
          })
          .finally(function () {
            if (btn.getAttribute("aria-disabled") !== "true") btn.disabled = false;
          });
      });
    });
  }

  function initQty() {
    document.querySelectorAll("[data-qty]").forEach(function (wrap) {
      var input = wrap.querySelector("input");
      var minus = wrap.querySelector("[data-qty-minus]");
      var plus = wrap.querySelector("[data-qty-plus]");
      if (!input) return;
      if (minus) {
        minus.addEventListener("click", function () {
          input.value = String(Math.max(1, Number(input.value || 1) - 1));
        });
      }
      if (plus) {
        plus.addEventListener("click", function () {
          input.value = String(Math.max(1, Number(input.value || 1) + 1));
        });
      }
    });
  }

  function initProductForms() {
    document.querySelectorAll("[data-product-form]").forEach(function (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        var idInput = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        if (!idInput || !window.BURR_PAW_CART) return;
        var btn = form.querySelector("[type='submit']");
        if (btn) btn.disabled = true;
        window.BURR_PAW_CART
          .addVariant(idInput.value, qtyInput ? qtyInput.value : 1)
          .then(function () {
            showToast("Added to cart");
          })
          .catch(function () {
            showToast("Could not add to cart");
          })
          .finally(function () {
            if (btn) btn.disabled = false;
          });
      });
    });
  }

  function initDemoVideo() {
    document.querySelectorAll("[data-demo-video]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.classList.contains("is-playing")) return;
        var id = btn.getAttribute("data-youtube-id");
        if (!id) return;
        var iframe = document.createElement("iframe");
        iframe.className = "demo__frame";
        iframe.src =
          "https://www.youtube.com/embed/" +
          encodeURIComponent(id) +
          "?autoplay=1&rel=0&modestbranding=1";
        iframe.title = "Burr Paw Demonstration";
        iframe.allow =
          "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
        iframe.allowFullscreen = true;
        btn.classList.add("is-playing");
        btn.replaceChildren(iframe);
      });
    });

    // Product descriptions already include the same YouTube embed — remove duplicates
    // when the themed demo player is present.
    document.querySelectorAll("[data-strip-product-youtube] .rte iframe").forEach(function (iframe) {
      var src = (iframe.getAttribute("src") || "").toLowerCase();
      if (src.indexOf("youtube") === -1 && src.indexOf("youtu.be") === -1) return;
      var node = iframe;
      var parent = iframe.parentElement;
      while (
        parent &&
        !parent.classList.contains("rte") &&
        parent.children.length === 1 &&
        parent.textContent.replace(/\s+/g, "") === ""
      ) {
        node = parent;
        parent = parent.parentElement;
      }
      if (node && node.parentNode) node.parentNode.removeChild(node);
    });
  }

  function initStorySlideshow() {
    document.querySelectorAll("[data-story-slideshow]").forEach(function (root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll(".story-person"));
      var prev = root.querySelector("[data-story-prev]");
      var next = root.querySelector("[data-story-next]");
      if (slides.length < 2) {
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
        return;
      }
      var index = slides.findIndex(function (slide) {
        return slide.classList.contains("is-active");
      });
      if (index < 0) index = 0;

      function show(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          slide.classList.toggle("is-active", i === index);
        });
      }

      if (prev) {
        prev.addEventListener("click", function () {
          show(index - 1);
        });
      }
      if (next) {
        next.addEventListener("click", function () {
          show(index + 1);
        });
      }
    });
  }

  function initReviewCarousel() {
    var track = document.querySelector("[data-review-track]");
    var prev = document.querySelector("[data-review-prev]");
    var next = document.querySelector("[data-review-next]");
    if (!track || !prev || !next) return;

    function cardStep() {
      var card = track.querySelector(".review");
      if (!card) return 320;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      var max = track.scrollWidth - track.clientWidth;
      var x = track.scrollLeft;
      prev.disabled = x <= 4;
      next.disabled = x >= max - 4;
    }

    prev.addEventListener("click", function () {
      track.scrollBy({ left: -cardStep(), behavior: "smooth" });
    });
    next.addEventListener("click", function () {
      track.scrollBy({ left: cardStep(), behavior: "smooth" });
    });
    track.addEventListener("scroll", updateButtons, { passive: true });
    window.addEventListener("resize", updateButtons);
    updateButtons();
  }

  function initLogoLoop() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    document.querySelectorAll("[data-logo-loop]").forEach(function (stage) {
      var frames = Array.prototype.slice.call(stage.querySelectorAll("img"));
      if (frames.length < 2) return;
      var caption = stage.parentElement
        ? stage.parentElement.querySelector("[data-logo-caption]")
        : null;
      var index = frames.findIndex(function (img) {
        return img.classList.contains("is-active");
      });
      if (index < 0) index = 0;
      function show(next) {
        frames.forEach(function (img, i) {
          img.classList.toggle("is-active", i === next);
        });
        if (caption) {
          var label = frames[next].getAttribute("data-caption") || "";
          caption.classList.add("is-swapping");
          window.setTimeout(function () {
            caption.textContent = label;
            caption.classList.remove("is-swapping");
          }, 180);
        }
        index = next;
      }
      window.setInterval(function () {
        show((index + 1) % frames.length);
      }, 2300);
    });
  }

  function initCloseoutSlides() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    document.querySelectorAll("[data-closeout-slides]").forEach(function (stage) {
      var frames = Array.prototype.slice.call(stage.querySelectorAll("img"));
      if (frames.length < 2) return;
      var index = frames.findIndex(function (img) {
        return img.classList.contains("is-active");
      });
      if (index < 0) index = 0;
      window.setInterval(function () {
        index = (index + 1) % frames.length;
        frames.forEach(function (img, i) {
          img.classList.toggle("is-active", i === index);
        });
      }, 4500);
    });
  }

  function initProductGallery() {
    document.querySelectorAll("[data-product-gallery]").forEach(function (gallery) {
      var main = gallery.querySelector("[data-gallery-main]");
      var thumbs = Array.prototype.slice.call(
        gallery.querySelectorAll("[data-gallery-thumb]")
      );
      if (!main || thumbs.length < 2) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var src = thumb.getAttribute("data-gallery-thumb");
          if (!src) return;
          main.src = src;
          thumbs.forEach(function (btn) {
            var active = btn === thumb;
            btn.classList.toggle("is-active", active);
            if (active) btn.setAttribute("aria-current", "true");
            else btn.removeAttribute("aria-current");
          });
        });
      });
    });
  }

  function initNewsletterPopup() {
    var root = document.querySelector("[data-newsletter-popup]");
    if (!root) return;
    if (!document.body.classList.contains("home") && !document.body.classList.contains("template-index")) return;

    var seenKey = "burrpaw-nl-seen-v3";
    var storageKey = "burrpaw-nl-subscribed";
    var delayMs = Number(root.getAttribute("data-delay") || 4500);
    var previouslyFocused = null;
    var dismissLocked = false;
    var dialog = root.querySelector(".nl-popup__dialog");
    var form = root.querySelector("[data-newsletter-form]") || root.querySelector(".nl-popup__form") || root.querySelector("form");
    var success = root.querySelector("[data-newsletter-success]");
    var emailInput = root.querySelector("#nl-popup-email");
    var skipBtn = root.querySelector(".nl-popup__skip");

    function isCoarsePointer() {
      try {
        return window.matchMedia("(hover: none) and (pointer: coarse)").matches;
      } catch (err) {
        return "ontouchstart" in window;
      }
    }

    function hasSeen() {
      try {
        return window.localStorage.getItem(seenKey) === "1" || window.localStorage.getItem(storageKey) === "1";
      } catch (err) {
        return false;
      }
    }
    function markSeen() {
      try {
        window.localStorage.setItem(seenKey, "1");
      } catch (err) {}
    }
    function hasSubscribed() {
      try {
        return window.localStorage.getItem(storageKey) === "1";
      } catch (err) {
        return false;
      }
    }
    function markSubscribed() {
      try {
        window.localStorage.setItem(storageKey, "1");
        window.localStorage.setItem(seenKey, "1");
      } catch (err) {}
    }
    function getFocusable() {
      if (!dialog) return [];
      return Array.prototype.slice
        .call(
          dialog.querySelectorAll(
            'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
          )
        )
        .filter(function (el) {
          return !el.hasAttribute("hidden") && el.offsetParent !== null;
        });
    }
    function openPopup() {
      if (root.classList.contains("is-open")) return;
      previouslyFocused = document.activeElement;
      root.hidden = false;
      root.removeAttribute("hidden");
      void root.offsetWidth;
      root.classList.add("is-open");
      document.body.classList.add("is-nl-popup-open");
      // First tap on phones often hits the backdrop (hero is "tap anywhere")
      // and would close the offer before anyone sees it.
      dismissLocked = true;
      window.setTimeout(function () {
        dismissLocked = false;
      }, 1500);
      if (isCoarsePointer()) return;
      window.setTimeout(function () {
        if (emailInput && !root.classList.contains("is-success")) emailInput.focus();
        else if (dialog) {
          var focusable = getFocusable();
          if (focusable[0]) focusable[0].focus();
        }
      }, 40);
    }
    function closePopup() {
      if (dismissLocked) return;
      if (!root.classList.contains("is-open") && root.hidden) return;
      markSeen();
      root.classList.remove("is-open");
      document.body.classList.remove("is-nl-popup-open");
      window.setTimeout(function () {
        root.hidden = true;
        if (previouslyFocused && typeof previouslyFocused.focus === "function") {
          previouslyFocused.focus();
        }
      }, 320);
    }

    root.querySelectorAll("[data-newsletter-dismiss]").forEach(function (el) {
      el.addEventListener("click", function () {
        if (el.classList.contains("nl-popup__backdrop") && isCoarsePointer()) return;
        closePopup();
      });
    });

    if (form) {
      form.setAttribute("data-nocaptcha", "true");
      form.addEventListener(
        "submit",
        function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (root.classList.contains("is-success")) return;

          var submitBtn = form.querySelector('[type="submit"]');
          if (submitBtn) submitBtn.disabled = true;

          var action = form.getAttribute("action") || "/contact";
          var data = new FormData(form);

          function showSuccess() {
            root.classList.add("is-success");
            if (success) {
              success.hidden = false;
              success.setAttribute("tabindex", "-1");
              success.focus();
            }
            markSubscribed();
            if (skipBtn) skipBtn.textContent = "Close";
            // Swallow the same tap/click that submitted — otherwise "No Thanks"
            // slides into that spot and immediately dismisses the code.
            dismissLocked = true;
            window.setTimeout(function () {
              dismissLocked = false;
            }, 900);
            if (submitBtn) submitBtn.disabled = false;
          }

          // Post to Shopify customer/newsletter endpoint (same as previous theme footer).
          fetch(action, {
            method: "POST",
            body: data,
            credentials: "same-origin",
            headers: { Accept: "text/html" }
          })
            .then(function () {
              showSuccess();
            })
            .catch(function () {
              // Still acknowledge locally if the network blips after Shopify accepted the post.
              showSuccess();
            });
        },
        true
      );
    }

    document.addEventListener("keydown", function (event) {
      if (!root.classList.contains("is-open")) return;
      if (event.key === "Escape") {
        event.preventDefault();
        closePopup();
      }
    });

    if (hasSeen()) return;
    window.setTimeout(openPopup, delayMs);
  }

  function initToastibarMobile() {
    if (window.matchMedia && window.matchMedia("(min-width: 768px)").matches) return;

    function park(el) {
      if (!el || el.id !== "mps-sales-notification") return;
      if (!el.classList.contains("sn-activated")) return;
      el.style.setProperty("position", "fixed", "important");
      el.style.setProperty("left", "12px", "important");
      el.style.setProperty("right", "auto", "important");
      el.style.setProperty("bottom", "max(1.25rem, env(safe-area-inset-bottom, 0px))", "important");
      el.style.setProperty("top", "auto", "important");
      el.style.setProperty("z-index", "5001", "important");
      el.style.setProperty("opacity", "1", "important");
      el.style.setProperty("visibility", "visible", "important");
      el.style.setProperty("transform", "none", "important");
      el.style.setProperty("width", "min(366px, calc(100vw - 24px))", "important");
      el.style.setProperty("max-width", "calc(100vw - 24px)", "important");
      el.style.setProperty("pointer-events", "auto", "important");
    }

    function watch(el) {
      if (!el || el.getAttribute("data-bp-toast-watched") === "1") return;
      el.setAttribute("data-bp-toast-watched", "1");
      park(el);
      if (window.MutationObserver) {
        new MutationObserver(function () {
          park(el);
        }).observe(el, { attributes: true, attributeFilter: ["class", "style"] });
      }
    }

    var existing = document.getElementById("mps-sales-notification");
    if (existing) watch(existing);
    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        records.forEach(function (record) {
          Array.prototype.forEach.call(record.addedNodes, function (node) {
            if (!node || node.nodeType !== 1) return;
            if (node.id === "mps-sales-notification") watch(node);
            else if (node.querySelector) {
              var found = node.querySelector("#mps-sales-notification");
              if (found) watch(found);
            }
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }

    // ToastiBar loads the sales JSON on phones but never injects #mps-sales-notification
    // (app crash / plan-limit). Render the same purchases ourselves.
    var SHOW_MS = 6500;
    var GAP_MS = 9000;
    var index = 0;
    var hideTimer;
    var root;
    var stopped = false;

    function esc(str) {
      return String(str || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/"/g, "&quot;");
    }

    function popupOpen() {
      return document.body.classList.contains("is-nl-popup-open");
    }

    function appToastVisible() {
      var el = document.getElementById("mps-sales-notification");
      return !!(el && el.classList.contains("sn-activated") && el.offsetHeight > 8);
    }

    function salesList() {
      var cached =
        window.MPS_LOADER_SETTINGS && MPS_LOADER_SETTINGS.respSalesDataCached;
      return Array.isArray(cached) ? cached : [];
    }

    function timeAgo(iso) {
      var then = new Date(iso).getTime();
      if (!then) return "recently";
      var mins = Math.max(1, Math.round((Date.now() - then) / 60000));
      if (mins < 60) return mins + (mins === 1 ? " minute ago" : " minutes ago");
      var hours = Math.round(mins / 60);
      if (hours < 24) return hours + (hours === 1 ? " hour ago" : " hours ago");
      var days = Math.round(hours / 24);
      return days + (days === 1 ? " day ago" : " days ago");
    }

    function ensureRoot() {
      if (root) return root;
      root = document.createElement("aside");
      root.id = "bp-sales-toast";
      root.className = "bp-sales-toast";
      root.setAttribute("aria-live", "polite");
      document.body.appendChild(root);
      root.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-bp-toast-close]");
        if (!btn) return;
        e.preventDefault();
        stopped = true;
        root.classList.remove("is-visible");
      });
      return root;
    }

    function hide() {
      if (root) root.classList.remove("is-visible");
    }

    function show(item) {
      if (stopped || !item || popupOpen() || appToastVisible()) return;
      var el = ensureRoot();
      var name = item.sn_first_name || "Someone";
      var loc = [item.sn_city, item.sn_state].filter(Boolean).join(", ");
      var title = item.sn_title || "Burr Paw";
      var handle = item.sn_handle ? "/products/" + item.sn_handle : "/collections/all";
      var img = item.sn_img || "";
      var ago = item.sn_purchased_on ? timeAgo(item.sn_purchased_on) : "recently";
      el.innerHTML =
        '<a class="bp-sales-toast__card" href="' +
        esc(handle) +
        '">' +
        (img
          ? '<img class="bp-sales-toast__img" src="' + esc(img) + '" alt="" width="72" height="72">'
          : "") +
        '<span class="bp-sales-toast__copy"><span class="bp-sales-toast__text">' +
        esc(name) +
        (loc ? " in " + esc(loc) : "") +
        " purchased <strong>" +
        esc(title) +
        '</strong></span><span class="bp-sales-toast__meta">' +
        esc(ago) +
        "</span></span></a>" +
        '<button type="button" class="bp-sales-toast__close" data-bp-toast-close aria-label="Dismiss">&times;</button>';
      el.classList.add("is-visible");
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hide, SHOW_MS);
    }

    function tick() {
      var list = salesList();
      if (!list.length || stopped) return;
      show(list[index % list.length]);
      index += 1;
    }

    function waitThenRun() {
      if (stopped) return;
      if (popupOpen() || appToastVisible()) {
        hide();
        window.setTimeout(waitThenRun, 800);
        return;
      }
      if (!salesList().length) {
        window.setTimeout(waitThenRun, 1000);
        return;
      }
      tick();
      window.setTimeout(waitThenRun, GAP_MS);
    }

    window.setTimeout(waitThenRun, 5200);
  }

  function initRecentPurchasePopup() {
    var root = document.querySelector("[data-recent-purchase]");
    if (!root || root.getAttribute("data-enabled") !== "true") return;
    var items = Array.prototype.slice.call(root.querySelectorAll("[data-purchase-item]"));
    if (!items.length) return;
    var delay = Number(root.getAttribute("data-delay") || 6000);
    var interval = Number(root.getAttribute("data-interval") || 9000);
    var display = Number(root.getAttribute("data-display") || 5000);
    var index = 0;
    var hideTimer;

    function showNext() {
      items.forEach(function (el) {
        el.hidden = true;
      });
      var item = items[index % items.length];
      item.hidden = false;
      root.classList.add("is-visible");
      index += 1;
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        root.classList.remove("is-visible");
      }, display);
    }

    setTimeout(function () {
      showNext();
      setInterval(showNext, interval);
    }, delay);

    var close = root.querySelector("[data-purchase-close]");
    if (close) {
      close.addEventListener("click", function () {
        root.classList.remove("is-visible");
        root.setAttribute("data-enabled", "false");
      });
    }
  }

  function initCartPage() {
    var root = document.querySelector("[data-cart-page]");
    if (!root || !window.BURR_PAW_CART) return;

    var shopUrl = root.getAttribute("data-shop-url") || "/collections/all";
    var FLAT_SHIPPING = 7.5;

    function esc(str) {
      return String(str || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/"/g, "&quot;");
    }

    function itemImage(item) {
      var src = item.image || (item.featured_image && item.featured_image.url) || "";
      if (src.indexOf("//") === 0) src = "https:" + src;
      return src;
    }

    function shippingProgressHtml(subtotal) {
      var threshold = window.BURR_PAW_CART.FREE_SHIPPING_THRESHOLD;
      var remaining = Math.max(0, threshold - subtotal);
      var pct = Math.min(100, Math.round((subtotal / threshold) * 100));
      var unlocked = remaining <= 0;
      var label = unlocked
        ? "You’ve unlocked free shipping"
        : "Spend " + window.BURR_PAW_CART.formatPrice(remaining) + " more to get free shipping";
      var meta = unlocked
        ? "Free shipping applied"
        : window.BURR_PAW_CART.formatPrice(subtotal) + " / " + window.BURR_PAW_CART.formatPrice(threshold);

      return (
        '<div class="shipping-progress' +
        (unlocked ? " is-complete" : "") +
        '" role="status" aria-live="polite">' +
        '<div class="shipping-progress__copy">' +
        '<p class="shipping-progress__label">' +
        label +
        "</p>" +
        '<p class="shipping-progress__meta">' +
        meta +
        "</p>" +
        "</div>" +
        '<div class="shipping-progress__track" aria-hidden="true">' +
        '<div class="shipping-progress__fill" style="width:' +
        pct +
        '%"></div>' +
        "</div>" +
        '<span class="sr-only">Free shipping progress: ' +
        pct +
        " percent</span>" +
        "</div>"
      );
    }

    function render(cart) {
      var itemsEl = root.querySelector("[data-cart-items]");
      var summaryEl = root.querySelector("[data-cart-summary]");
      var emptyEl = root.querySelector("[data-cart-empty]");
      if (!itemsEl || !summaryEl || !emptyEl) return;

      if (!cart.items || !cart.items.length) {
        itemsEl.hidden = true;
        summaryEl.hidden = true;
        emptyEl.hidden = false;
        return;
      }

      emptyEl.hidden = true;
      itemsEl.hidden = false;
      summaryEl.hidden = false;

      itemsEl.innerHTML = cart.items
        .map(function (item) {
          var img = itemImage(item);
          var title = item.product_title || item.title || "";
          var unitPrice = item.final_price != null ? item.final_price : item.price;
          return (
            '<article class="cart-item" data-key="' +
            esc(item.key) +
            '">' +
            '<a class="cart-item__image" href="' +
            esc(item.url) +
            '">' +
            (img
              ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="160" height="160">'
              : "") +
            "</a>" +
            '<div class="cart-item__details">' +
            '<h2 class="cart-item__title"><a href="' +
            esc(item.url) +
            '">' +
            esc(title) +
            "</a></h2>" +
            '<p class="cart-item__price">' +
            window.BURR_PAW_CART.money(unitPrice) +
            "</p>" +
            "</div>" +
            '<div class="cart-item__actions">' +
            '<div class="cart-qty">' +
            '<button type="button" class="cart-qty__btn" data-qty-change="-1" aria-label="Decrease quantity">−</button>' +
            '<input type="number" class="cart-qty__input" value="' +
            item.quantity +
            '" min="1" max="99" aria-label="Quantity" data-cart-qty-input>' +
            '<button type="button" class="cart-qty__btn" data-qty-change="1" aria-label="Increase quantity">+</button>' +
            "</div>" +
            '<p class="cart-item__line-total">' +
            window.BURR_PAW_CART.money(item.final_line_price) +
            "</p>" +
            '<button type="button" class="cart-item__remove" data-remove>Remove</button>' +
            "</div>" +
            "</article>"
          );
        })
        .join("");

      var threshold = window.BURR_PAW_CART.FREE_SHIPPING_THRESHOLD;
      var subtotal = cart.total_price / 100;
      var shipping = subtotal >= threshold ? 0 : FLAT_SHIPPING;
      var total = subtotal + shipping;

      summaryEl.innerHTML =
        '<div class="cart-summary">' +
        '<h2 class="cart-summary__title">Order summary</h2>' +
        shippingProgressHtml(subtotal) +
        '<div class="cart-summary__row"><span>Subtotal</span><span>' +
        window.BURR_PAW_CART.money(cart.total_price) +
        "</span></div>" +
        '<div class="cart-summary__row"><span>Shipping</span><span>' +
        (shipping === 0 ? "Free" : window.BURR_PAW_CART.formatPrice(shipping)) +
        "</span></div>" +
        '<div class="cart-summary__row cart-summary__row--total"><span>Total</span><span>' +
        window.BURR_PAW_CART.formatPrice(total) +
        "</span></div>" +
        '<a class="btn btn--blaze cart-summary__checkout" href="/checkout">Checkout</a>' +
        '<a class="cart-summary__continue" href="' +
        esc(shopUrl) +
        '">Continue shopping</a>' +
        "</div>";

      itemsEl.querySelectorAll(".cart-item").forEach(function (line) {
        var key = line.getAttribute("data-key");
        var item = cart.items.find(function (i) {
          return i.key === key;
        });
        var input = line.querySelector("[data-cart-qty-input]");
        line.querySelectorAll("[data-qty-change]").forEach(function (btn) {
          btn.addEventListener("click", function () {
            var delta = Number(btn.getAttribute("data-qty-change"));
            var current = item ? item.quantity : Number(input && input.value) || 1;
            window.BURR_PAW_CART.changeLine(key, Math.max(0, current + delta));
          });
        });
        if (input) {
          input.addEventListener("change", function () {
            window.BURR_PAW_CART.changeLine(key, Math.max(0, Number(input.value || 1)));
          });
        }
        var remove = line.querySelector("[data-remove]");
        if (remove) {
          remove.addEventListener("click", function () {
            window.BURR_PAW_CART.changeLine(key, 0);
          });
        }
      });
    }

    document.addEventListener("burrpaw:cart-updated", function (e) {
      render(e.detail);
    });
    window.BURR_PAW_CART.fetchCart().then(render);
  }

  document.addEventListener("DOMContentLoaded", function () {
    var boot = [
      function () { if (window.BURR_PAW_CART) window.BURR_PAW_CART.updateHeaderBadge(); },
      initHeader,
      initHeroVideo,
      initReveals,
      initDemoVideo,
      initQty,
      initAddButtons,
      initProductForms,
      initStorySlideshow,
      initReviewCarousel,
      initLogoLoop,
      initCloseoutSlides,
      initProductGallery,
      initNewsletterPopup,
      initToastibarMobile,
      initRecentPurchasePopup,
      initCartPage
    ];
    boot.forEach(function (fn) {
      try {
        fn();
      } catch (err) {
        if (window.console && console.error) console.error("Burr Paw init error", err);
      }
    });
  });
})();
